import React from "react";
import translate from "../../../../lib/translate";

import * as style from "./VacancyTeaserContent.module.less";

export function VacancyTeaserContent({ code, from, typ, place }) {
    return (
        <span className={style.vacancyMeta}>
            {`${code} | ${from} | ${place} | ${translate(
                `vacancy.detail.jobtype.${typ}`
            )}`}
        </span>
    );
}
